export default __webpack_public_path__ + "static/media/ingress-protection.be6c352b.png";